var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_9886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1316 13.6298C1.95223 12.5505 1.95223 11.449 2.1316 10.3698C3.2336 10.3958 4.2236 9.86777 4.6086 8.93877C4.9936 8.00877 4.6666 6.93477 3.8686 6.17577C4.50501 5.28505 5.28416 4.50557 6.1746 3.86877C6.9346 4.66677 8.0086 4.99377 8.9386 4.60877C9.8686 4.22377 10.3956 3.23277 10.3686 2.13177C11.4485 1.95217 12.5507 1.95217 13.6306 2.13177C13.6036 3.23377 14.1316 4.22377 15.0606 4.60877C15.9906 4.99377 17.0646 4.66677 17.8236 3.86877C18.7143 4.50518 19.4938 5.28433 20.1306 6.17477C19.3326 6.93477 19.0056 8.00877 19.3906 8.93877C19.7756 9.86877 20.7666 10.3958 21.8676 10.3688C22.0472 11.4487 22.0472 12.5508 21.8676 13.6308C20.7656 13.6038 19.7756 14.1318 19.3906 15.0608C19.0056 15.9908 19.3326 17.0648 20.1306 17.8238C19.4942 18.7145 18.715 19.494 17.8246 20.1308C17.0646 19.3328 15.9906 19.0058 15.0606 19.3908C14.1306 19.7758 13.6036 20.7668 13.6306 21.8678C12.5507 22.0474 11.4485 22.0474 10.3686 21.8678C10.3956 20.7658 9.8676 19.7758 8.9386 19.3908C8.0086 19.0058 6.9346 19.3328 6.1756 20.1308C5.28489 19.4944 4.5054 18.7152 3.8686 17.8248C4.6666 17.0648 4.9936 15.9908 4.6086 15.0608C4.2236 14.1308 3.2326 13.6038 2.1316 13.6308V13.6298ZM11.9996 14.9998C12.7952 14.9998 13.5583 14.6837 14.1209 14.1211C14.6835 13.5585 14.9996 12.7954 14.9996 11.9998C14.9996 11.2041 14.6835 10.4411 14.1209 9.87845C13.5583 9.31584 12.7952 8.99977 11.9996 8.99977C11.204 8.99977 10.4409 9.31584 9.87828 9.87845C9.31567 10.4411 8.9996 11.2041 8.9996 11.9998C8.9996 12.7954 9.31567 13.5585 9.87828 14.1211C10.4409 14.6837 11.204 14.9998 11.9996 14.9998Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_9886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.5488b45cfd99e29224110c2c153a458a.svg";
export { ForwardRef as ReactComponent };